import { Outlet } from "react-router";
import AdminSidebar from "@/src/common/layouts/admin-sidebar";

const AdminLayout: React.FC = () => (
	<div className="flex min-h-dvh bg-background">
		<AdminSidebar />
		<div className="flex min-h-dvh min-w-0 flex-1 flex-col">
			<main className="mx-auto flex w-full max-w-5xl flex-1 flex-col px-4 py-6 lg:px-8">
				<Outlet />
			</main>
		</div>
	</div>
);

export default AdminLayout;
